import { render, staticRenderFns } from "./VisitStatus.vue?vue&type=template&id=4c2b76d4"
import script from "./VisitStatus.vue?vue&type=script&lang=js"
export * from "./VisitStatus.vue?vue&type=script&lang=js"
import style0 from "./VisitStatus.vue?vue&type=style&index=0&id=4c2b76d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports